import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourOptionsApi from '@/features/dashboard/tourOptions/api/tourOptionsApi.ts';
import { tourOptionsApiQueryKeys } from '@/features/dashboard/tourOptions/api/tourOptionsApi.queryKeys.ts';
import { TourOptionUsageDto } from '@/features/dashboard/tourOptions/types/TourOptionUsageDto.ts';

const useGetTourOptionUsage = (optionId: string | undefined) => {
  return useQuery(getTourOptionUsageQueryOptions(optionId));
};

export const getTourOptionUsageQueryOptions = (
  optionId: string | undefined,
): UseQueryOptions<TourOptionUsageDto> => ({
  queryKey: tourOptionsApiQueryKeys.usageByOptionId(optionId ?? ''),
  queryFn: () => tourOptionsApi.getUsage(optionId!),
  enabled: !!optionId,
});

export default useGetTourOptionUsage;
